import { faro } from '@grafana/faro-react';
import { journeyAttributes } from './journeySchema.mjs';

export function trackJourney(action, details = {}) {
  try {
    const attributes = journeyAttributes(action, {
      ...details,
      pathname: typeof window === 'undefined' ? '' : window.location.pathname
    });
    if (attributes) faro.api?.startUserAction(action, attributes);
  } catch {
    // Telemetry must never interrupt shopping or payment.
  }
}
